var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cell small-12 medium-8 large-8 Overview_view"},[_c('div',{staticClass:"grid-x grid-margin-y grid-margin-x"},[_c('div',{staticClass:"cell small-12 medium-12 large-6"},[_c('ProfileBookingsOverviewCard')],1),_c('div',{staticClass:"cell small-12 medium-12 large-6"},[_c('ProfileGuestOverviewCard')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }